// extracted by mini-css-extract-plugin
export var emptyState = "_63-d";
export var statCard = "_63-c";
export var table = "_63-0";
export var tableCell = "_63-4";
export var tableCellClickable = "_63-5 _63-4";
export var tableCellDefault = "_63-6 _63-4";
export var tableCellEmpty = "_63-8";
export var tableCellWithValue = "_63-7";
export var tableContainer = "_63-e";
export var tableHeaderWeight = "_63-1";
export var tableHeaderZone = "_63-2";
export var tableRowHeader = "_63-3";
export var viewModeButton = "_63-9";
export var viewModeButtonActive = "_63-a _63-9";
export var viewModeButtonInactive = "_63-b _63-9";